import { createSelector } from 'reselect';

import { NAME } from './constants';

export const getModel = (state) => state[NAME];

export const getHasNewVersionAvailable = createSelector(
    getModel,
    (model) => model.newVersionAvailable,
);
